// extracted by mini-css-extract-plugin
export var deleteIcon = "_op-5";
export var deleteOption = "_op-3";
export var divider = "_op-2";
export var downloadIcon = "_op-4";
export var drawer = "_op-0";
export var drawerFooter = "_op-6";
export var drawerOpen = "_op-1";
export var highlighted = "_op-7";
export var lighterHighlight = "_op-8";